export const START_PERIOD_TIME_ADJUST = 24 * 60 * 60
